export default {
  data() {
    return {
      divisionId: undefined,
    };
  },
};
